<template>
	<div class="service1">
		<div class="service1-c">
			<div class="service1-info">
				<div class="service1-info-h">scope of investment</div>
				<div class="service1-info-s">
					Based on the principle of "win-win cooperation and risk sharing", the company seeks partners worldwide to invest in and develop high-quality photovoltaic (with a focus on industrial and commercial distributed and ground centralized power stations), wind power, energy storage, and power projects.
				</div>
			    <div class="service1-info-f">
			    	<div class="item">
						<img class="item-bg" src="../../../assets/newimg/301.jpg" alt="">
						<img class="icon1" src="../../../../public/images/guangfu@2x.png" alt="">
						<div class="t">photovoltaic</div>
						<div class="s"></div>
					</div>
					<div class="item">
						<img class="item-bg" src="../../../assets/newimg/302.jpg" alt="">
						<img class="icon1" src="../../../../public/images/fengdian@2x.png" alt="">
						<div class="t">Wind power</div>
						<div class="s"></div>
					</div>
					<div class="item">
						<img class="item-bg" src="../../../assets/newimg/303.jpg" alt="">
						<img class="icon1" src="../../../../public/images/a-ziyuan25@2x.png" alt="">
						<div class="t">Energy storage</div>
						<div class="s"></div>   
					</div>
					<div class="item">
						<img class="item-bg" src="../../../assets/service/service-44.png" alt="">
						<img class="icon1" src="../../../../public/images/dianli@2x.png" alt="">
						<div class="t">power</div>
						<div class="s"></div>
					</div>
			    </div>
			</div>
		</div>
		
		<!-- 投资模式 -->
		<div class="service-c2">
			<div class="service-c2-c">
				<div class="h">
					<div class="h-l">Investment model</div>
					<div class="h-r">
						<div class="t">Energy management mode</div>
						<div class="s">Owners rent roofs or land, companies invest in the construction and operation of power stations, and owners enjoy electricity discounts or rent;</div>
						<div class="b">invest</div>
					</div>
				</div>
				<div class="f">
					<div class="" style="cursor: pointer;" :class="selectIndex==index?'item':''" v-for="(item, index) in ['Energy management mode', 'Joint venture and co construction model']" :key="index"
					@click="tapList(index)">
						{{item}}
					</div>
				</div>
			</div>
		</div>
	    
		<div class="service-c3">
			<div class="service-c3-c">
				<div class="t">Investment Outlook</div>
				<div class="s">In the next three years</div>
				<div class="f">
					<div class="item">
						<div class="item-h">20 <span>hundred million</span></div>
						<div class="item-f">Expected investment</div>
					</div>
					<div class="item">
						<div class="item-h">20 <span>GW</span></div>
						<div class="item-f">Constructing new energy projects</div>
					</div>
				</div>
			</div>
		</div>
		
		
		
		<div class="service-c6">
			<img class="service-c6-bgimg" src="../../../assets/newimg/304.jpg" alt="" />
			<div class="service-c6-title">
				<div class="service-c6-title-1">During the cooperation period</div>
				<div class="service-c6-title-2">The company provides technical and business support</div>
			</div>
			<div class="service-c6-sec">
				<div class="item">
					<div class="item-h">①</div>
					<div class="item-f">Preliminary survey</div>
				</div>
				<div class="item">
					<div class="item-h">②</div>
					<div class="item-f">System scheme design</div>
				</div>
				<div class="item">
					<div class="item-h">③</div>
					<div class="item-f">investment budget</div>
				</div>
				<div class="item">
					<div class="item-h">④</div>
					<div class="item-f">Business docking</div>
				</div>
				<div class="item">
					<div class="item-h">⑤</div>
					<div class="item-f">Investment and financing support</div>
				</div>
				<div class="item">
					<div class="item-h">⑥</div>
					<div class="item-f">Technical guidance and training</div>
				</div>
			</div>
		</div>
		
		<div class="service-c5">
			<div class="service-c5-c">
				<div class="h">invest</div>
				<div class="f">
					<div class="f-l">
						<div class="item110">
							<div class="item5">
								<div class="item5-h">
									corporate name
								</div>
								<el-input placeholder="Please enter the company name"></el-input>
							</div>
							<div class="item5">
								<div class="item5-h">
									Contact Number
								</div>
								<el-input placeholder="Please enter your contact phone number"></el-input>
							</div>
						</div>
						<div class="item110">
							<div class="item5">
								<div class="item5-h">
									province
								</div>
								<el-input placeholder="Please enter the province"></el-input>
							</div>
							<div class="item5">
								<div class="item5-h">
									city
								</div>
								<el-input placeholder="Please enter the city"></el-input>
							</div>
						</div>
						<div class="item10">
							<div class="item10-h">
								notes
							</div>
							<el-input placeholder="Please enter a note"></el-input>
						</div>
						<!-- <div class="itemyz">
							<div class="itemyz-h">Verification code</div>
							<div class="itemyz-f">
								<el-input placeholder="Please enter the verification code"></el-input>
								<div class="code">2212</div>
							</div>
							
						</div> -->
						<div style="cursor: pointer;" class="button">Submit Now</div>
					</div>
					<div class="f-r">
						<div class="s1">Collaboration Hotline：</div>
						<div class="s2">0571-86392006</div>
						<div class="s3">Zhejiang Zhonggai Electric Power Engineering Co., Ltd</div>
						<img src="../../../assets/ys/service/编组 14.png" alt="">
					</div>
				</div>
			</div>
		</div>
		
	</div>
</template>

<script>
	export default {
		props: {
			list: {
				type: Array,
				default: []
			}
		},
		data() {
			return {
				selectIndex:0

			}
		},
		created() {

		},
		methods: {
			tapList(index) {
				this.selectIndex = index
			}

		}
	}
</script>

<style lang="scss">
	div {
		box-sizing: border-box;
	}

	.service1 {
 		
		.service-c2 {
			 
			display: flex; 
			justify-content: center;
			background-image: url(../../../assets/service/bg2@2x.png);
			position: relative;
			
			.service-c2-c {  
				 
				.h {
					 
					justify-content: space-between;
					color: #FFFFFF;
					 
					.h-r {
 						display: flex;
						flex-direction: column;
						justify-content: center;
						align-items: center;
						.t {
							font-weight: 500;
 						}
						.s {
							 
						}
						.b {
							 
							border: 1px solid white;
							text-align: center;
							
						}
						.b:hover {
							background-color: #22A3D3;
							color: white;
							border: 0;
						}
					}
				}
			    
			}
			.f {
				position: absolute;
				 
				justify-content: space-between;
				align-items: center;
				border-top: 1px solid white;
				div {
					 
					text-align: center;
					color: white;
					background-color: rgba(0, 0, 0, 0);
				}
				.item {
					background-color: #22A3D3;
				}
			}
		}
		
		.service-c3 {
		 
			background-color: white;
 			justify-content: center;
 			text-align: center;
			.service-c3-c {
				 
				.t {
					font-weight: 500;
 					color: #332C2B;
				}
				.s{
					 
					color: #332C2B;
				}
				.f {
 					display: flex;
					justify-content: space-between;
					align-items: center;
					
					.item {
						flex: 1;
						color:white;
						
						
						.item-h {
 							
						}
						.item-f {
  							color: #332C2B;
						}
					}
				}
			}
		}
		
		
		
		.service1-c {
			 
			background-color: white;
 			justify-content: center;
 
			.service1-info {
				 
				text-align: center;

				.service1-info-h {
 					color: #332C2B;
				}
				.service1-info-s {
					 
					color: #999999;
				}

				.service1-info-f {
 					justify-content: space-between;
					align-items: center;
					.item {
						color: white;
 						flex-direction: column;
						justify-content: flex-end;
						position: relative;
						transition: transform 0.3s;
						.item-bg {
							object-fit: cover;
						}
						.s {
							text-align: left;
							position: relative;
							z-index: 3;
						}
						.t {
						 	text-align: left;
							font-weight: 500;
							position: relative;
							z-index: 3;
						}
						.icon1 {
							position: relative;
							z-index: 3;
						}
					}
					.item:hover {
					       transition: width 0.3s, height 0.3s;
					       transform: scale(0.95);
					       
					      }
				}
			}
		}
		
		.service-c6 {
			width: 100%;
			position: relative;
			color: white;
			.service-c6-bgimg {
				width: 100%;
				min-height: 300px;
				height: auto;
			}
			.service-c6-title {
				position: absolute;
				.service-c6-title-1 {
					font-weight: 500;
					color: #333;
				}
				.service-c6-title-2 {
					font-weight: 500;
					color: #333;
				}
			}
			.service-c6-sec {
				position: absolute;
				top: 0;
				height: 100%;
				z-index: 99;
				display: flex;
				justify-content: space-between;
				align-items: center;
				
				border-left: 1px solid rgba(255, 255, 255, 0.5);
				.item {
					flex: 1;
					height: 100%;
					display: flex;
					flex-direction: column;
					justify-content: center;
					align-items: center;
					border-right: 1px solid rgba(255, 255, 255, 0.5);
					.item-h {
						color: #333;
					}
					.item-f {
						color: #333;
						
					}
				}
			}
		}

		.service-c5 {
			
			background-color: white;
			justify-content: center;
			
			.service-c5-c {
				
				.h {
					color: #332C2B;
				}
				.f {
					justify-content: space-between;
					.f-l {
						
						.item110 {
							
							justify-content: space-between;
							align-items: center;
							.item5 {
								
								div {
									color: #332C2B;
								}
								input {
									
								}
							}
							
						}
						.item10 {
							div {
								color: #332C2B;
							}
							input {
								
								
							}
						}
						
						.itemyz {
							.itemyz-h {
								color: #332C2B;
							}
							.itemyz-f {
								
								justify-content: flex-start;
								align-items: center;
								
								.code {
									background-color: #f1f1f1;
									
									text-align: center;
									border: 1px solid #eee;
									
								}
							}
						}
						.button {
							
							text-align: center;
							color: white;
							background-color: #22A3D3;
						}
					}
					.f-r {
						.s1 {
							color: #332C2B;
						}
						.s2 {
						
							color: #332C2B;
						}
						.s3 {
							color: #332C2B;
						}
						
					}
				}
				
			
			}
		}
	
	}
	
	@media screen and (min-width: 1200px) {
		.service1 {
			width: 100%;
			
			.service-c2 {
				width: 100%;
				height: 890px;
				display: flex; 
				.service-c2-c {  
					width: 1200px;
					.h {
						width: 100%;
						// height: 800px;
						padding: 72px 0;
						display: flex;
						.h-l {
							width: 50%;
							font-size: 56px;
							
						}
						.h-r {
							// width: 50%;
							display: flex;
							margin-top: 160px;
							.t {
								font-size: 48px;
							}
							.s {
								margin-top: 16px;
								font-size: 24px;
							}
							.b {
								margin-top: 56px;
								width: 220px;
								height: 56px;
								line-height: 56px;
								font-size: 18px;
								border: 1px solid white;
								
							}
						}
					}
				    
				}
				.f {
					bottom: 0;
					left: 0;
					width: 100%;
					height: 100px;
					display: flex;
					border-top: 1px solid white;
					div {
						width: 50%; 
						height: 100px;
						line-height: 100px;
					}
					
				}
			}
			
			.service-c3 {
				width: 100%;
				height: 430px;
				display: flex; 
				padding: 80px 0 80px;
				.service-c3-c {
					width: 1200px;
					.t {
						font-size: 32px;
					}
					.s{
						margin-top: 32px;
						font-size: 24px;
					}
					.f {
						margin-top: 40px;
						display: flex;
						
						.item {
							flex: 1;							
							
							.item-h {
								font-size: 45px;
								color: #22A3D3;
								span {
									font-size: 18px;
								}
							}
							.item-f {
								margin-top: 30px;
								font-size: 24px;
							}
						}
					}
				}
			}
			
			
			
			.service1-c {
				width: 100%;
				height: 790px;
				display: flex; 
				padding: 120px 0 80px;
		
				.service1-info {
					width: 1200px;
		
					.service1-info-h {
						font-size: 32px;
					}
					.service1-info-s {
						margin-top: 16px;
						font-size: 16px;
					}
		
					.service1-info-f {
						margin-top: 40px;
						display: flex;
						.item {
							width: calc(25% - 10px);
							height: 466px;
							padding: 24px;
							display: flex;
							.item-bg {
								position: absolute;
								top: 0;
								left: 0;
								width: 100%;
								height: 466px;
								z-index: 0;
							}
							.s {
								margin-top:8px;
								font-size: 18px;
							}
							.t {
								margin-top: 16px;
								font-size: 32px;
							}
							.icon1 {
								width: 40px;
								height: 40px;
							}
						}
					}
				}
			}
			
			.service-c6 {
				position: relative;
				.service-c6-bgimg {
					min-height: 300px;
				}
				.service-c6-title {
					top: 50px;
					left:calc(50% - 600px);
					width: 1200px;
					.service-c6-title-1 {
						font-size: 21px;
					}
					.service-c6-title-2 {
						margin-top: 20px;
						font-size: 32px;
					}
				}
				.service-c6-sec {
					left:calc(50% - 600px);
					width: 1200px;
					.item {
						.item-h {
							font-size: 28px;
						}
						.item-f {
							margin-top: 10px;
							font-size: 20px;
							height: 60px;
							
						}
					}
				}
			}
		
			.service-c5 {
				width: 100%;
				height: 850px;
				display: flex; 
				padding: 80px 0 80px;
				
				.service-c5-c {
					width: 1200px;
					.h {
						font-size: 32px;
					}
					.f {
						width: 100%;
						margin-top: 40px;
						display: flex;
						.f-l {
							width: calc(60% - 30px);
							
							.item110 {
								margin-bottom: 24px;
								width: 100%;
								height: 100px;
								display: flex;
								.item5 {
									margin-bottom: 24px;
									width: calc(50% - 20px);
									div {
										font-size: 18px;
										margin-bottom: 16px;
									}
									input {
										width: 100%;
										height: 55px;
										margin-bottom: 0;
										
									}
								}
								
							}
							.item10 {
								width: 100%;
								div {
									font-size: 18px;
									margin-bottom: 16px;
								}
								input {
									width: 100%;
									height: 55px;
									margin-bottom: 0;
									
								}
							}
							
							.itemyz {
								margin-bottom: 24px;
								.itemyz-h {
									font-size: 18px;
									margin-bottom: 16px;
								}
								.itemyz-f {
									width: 100%;
									margin-top: 16px;
									display: flex;
									input {
										width: 500px;
										height: 55px;
									}  
									.code {
										margin-left: 24px;
										width: 160px;
										height: 55px;
										border: 1px solid #eee;
										line-height: 55px;
										border-radius: 4px;
									}
								}
							}
							.button {
								width: 220px;
								height: 55px;
								line-height: 55px;
							}
						}
						.f-r {
							width: 40%;
							.s1 {
								font-size: 18px;
							}
							.s2 {
								margin-top: 16px;
								font-size: 56px;
							}
							.s3 {
								font-size: 18px;
							}
							img {
								margin-top: 80px;
								width: 300px;
								height: 300px;
							}
						}
					}
					
				
				}
			}
		}
	
	}
	@media screen and (max-width: 1200px) {
		.service1 {
			width: 100%;
			
			.service-c2 {
				width: 100%;
				height: 700px;
				display: flex; 
				.service-c2-c {  
					width: 100%;
					.h {
						width: 100%;
						height: 700px;
						padding: 60px 0;
						display: flex;
						.h-l {
							width: 50%;
							font-size: 40px;
							
						}
						.h-r {
							// width: 50%;
							margin-top: 120px;
							display: flex;
							.t {
								font-size: 32px;
							}
							.s {
								margin-top: 12px;
								font-size: 18px;
							}
							.b {
								margin-top: 24px;
								width: 180px;
								height: 50px;
								line-height: 50px;
								font-size: 16px;
								border: 1px solid white;
								
							}
						}
					}
				    
				}
				.f {
					bottom: 0;
					left: 0;
					width: 100%;
					height: 70px;
					display: flex;
					border-top: 1px solid white;
					div {
						width: 50%; 
						height: 70px;
						line-height: 70px;
					}
					
				}
			}
			
			.service-c3 {
				width: 100%;
				height: 400px;
				display: flex; 
				padding: 60px 0;
				.service-c3-c {
					width: 100%;
					.t {
						font-size: 28px;
					}
					.s{
						margin-top: 24px;
						font-size: 24px;
					}
					.f {
						margin-top: 30px;
						display: flex;
						
						.item {
							flex: 1;							
							
							.item-h {
								font-size: 30px;
								color: #22A3D3;
								span {
									font-size: 15px;
								}
							}
							.item-f {
								margin-top: 20px;
								font-size: 18px;
							}
						}
					}
				}
			}
			
			
			
			.service1-c {
				width: 100%;
				height: 600px;
				display: flex; 
				padding: 80px 20px 60px;
		
				.service1-info {
					width: 100%;
		
					.service1-info-h {
						font-size: 28px;
					}
					.service1-info-s {
						margin-top: 12px;
						font-size: 14px;
					}
		
					.service1-info-f {
						margin-top: 24px;
						display: flex;
						.item {
							width: calc(25% - 10px);
							height: 400px;
							padding: 24px;
							display: flex;
							.item-bg {
								position: absolute;
								top: 0;
								left: 0;
								width: 100%;
								height: 400px;
								z-index: 0;
							}
							.s {
								margin-top:8px;
								font-size: 16px;
							}
							.t {
								margin-top: 12px;
								font-size: 24px;
							}
							.icon1 {
								width: 30px;
								height: 30px;
							}
						}
					}
				}
			}
			
			.service-c6 {
				position: relative;
				.service-c6-bgimg {
					min-height: 300px;
				}
				.service-c6-title {
					top: 40px;
					left:30px;
					width: 100%;
					.service-c6-title-1 {
						font-size: 18px;
					}
					.service-c6-title-2 {
						margin-top: 16px;
						font-size: 24px;
					}
				}
				.service-c6-sec {
					left:0;
					width: 100%;
					.item {
						.item-h {
							font-size: 20px;
						}
						.item-f {
							margin-top: 6px;
							font-size: 16px;
							height: 50px;
						}
					}
				}
			}
		
			.service-c5 {
				width: 100%;
				// height: 850px;
				display: flex; 
				padding: 40px 0;
				
				.service-c5-c {
					width: 100%;
					padding: 0 20px;
					.h {
						font-size: 24px;
					}
					.f {
						width: 100%;
						margin-top: 20px;
						display: flex;
						.f-l {
							width: calc(60% - 20px);
							
							.item110 {
								margin-bottom: 18px;
								width: 100%;
								height: 80px;
								display: flex;
								.item5 {
									margin-bottom: 18px;
									width: calc(50% - 20px);
									div {
										font-size: 16px;
										margin-bottom: 12px;
									}
									input {
										width: 100%;
										height: 40px;
										margin-bottom: 0;
										
									}
								}
								
							}
							.item10 {
								width: 100%;
								div {
									font-size: 16px;
									margin-bottom: 14px;
								}
								input {
									width: 100%;
									height: 40px;
									margin-bottom: 0;
									
								}
							}
							
							.itemyz {
								margin-bottom: 18px;
								.itemyz-h {
									font-size: 16px;
									margin-bottom: 14px;
								}
								.itemyz-f {
									width: 100%;
									margin-top: 12px;
									display: flex;
									input {
										width: 400px;
										height: 40px;
									}  
									.code {
										margin-left: 18px;
										width: 160px;
										height: 40px;
										border: 1px solid #eee;
										line-height: 40px;
										border-radius: 4px;
									}
								}
							}
							.button {
								width: 180px;
								height: 40px;
								line-height: 40px;
							}
						}
						.f-r {
							width: 40%;
							.s1 {
								font-size: 16px;
							}
							.s2 {
								margin-top: 12px;
								font-size: 40px;
							}
							.s3 {
								font-size: 16px;
							}
							img {
								margin-top: 60px;
								width: 240px;
								height: 240px;
							}
						}
					}
					
				
				}
			}
		}
	
	}
	@media screen and (max-width: 880px) {
		.service1 {
			width: 100%;
			
			.service-c2 {
				width: 100%;
				height: 500px;
				display: flex; 
				.service-c2-c {  
					width: 100%;
					.h {
						width: 100%;
						height: 500px;
						padding: 40px 0;
						display: flex;
						.h-l {
							width: 50%;
							font-size: 20px;
						}
						.h-r {
							width: 100%;
							height: 240px;
							display: flex;
							margin-top: 80px;
							.t {
								font-size: 18px;
							}
							.s {
								margin-top: 10px;
								font-size: 15px;
							}
							.b {
								margin-top: 18px;
								width: 120px;
								height: 40px;
								line-height: 40px;
								font-size: 14px;
								border: 1px solid white;
								
							}
						}
					}
				    
				}
				.f {
					bottom: 0;
					left: 0;
					width: 100%;
					height: 50px;
					display: flex;
					border-top: 1px solid white;
					div {
						width: 50%; 
						height: 50px;
						line-height: 50px;
					}
					
				}
			}
			
			.service-c3 {
				width: 100%;
				height: 300px;
				display: flex; 
				padding: 40px 0;
				.service-c3-c {
					width: 100%;
					.t {
						font-size: 18px;
					}
					.s{
						margin-top: 18px;
						font-size: 18px;
					}
					.f {
						margin-top: 20px;
						display: flex;
						
						.item {
							flex: 1;							
							
							
							.item-h {
								font-size: 22px;
								color: #22A3D3;
								span {
									font-size: 13px;
								}
							}
							.item-f {
								margin-top: 16px;
								font-size: 14px;
							}
						}
					}
				}
			}
			
			
			
			.service1-c {
				width: 100%;
				display: flex; 
				padding: 30px 12px 30px;
		
				.service1-info {
					width: 100%;
		
					.service1-info-h {
						font-size: 18px;
					}
					.service1-info-s {
						margin-top: 12px;
						font-size: 13px;
					}
		
					.service1-info-f {
						margin-top: 20px;
						display: flex;
						flex-wrap: wrap;
						.item {
							width: calc(50% - 10px);
							height: 200px;
							padding: 24px;
							display: flex;
							
							margin-bottom: 12px;
							.item-bg {
								position: absolute;
								top: 0;
								left: 0;
								width: 100%;
								height: 200px;
								z-index: 0;
							}
							.s {
								margin-top:8px;
								font-size: 13px;
							}
							.t {
								margin-top: 12px;
								font-size: 15px;
							}
							.icon1 {
								width: 20px;
								height: 20px;
							}
						}
					}
				}
			}
			
			.service-c6 {
				position: relative;
				.service-c6-bgimg {
					min-height: 300px;
					opacity:0.4;
				}
				.service-c6-title {
					top: 30px;
					left:20px;
					// width: 100%;
					width:auto;
					.service-c6-title-1 {
						font-size: 13px;
					}
					.service-c6-title-2 {
						margin-top: 10px;
						font-size: 15px;
					}
				}
				.service-c6-sec {
					left:0;
					width: 100%;
					.item {
						.item-h {
							font-size: 14px;
						}
						.item-f {
							margin-top: 6px;
							font-size: 10px;
							height: 40px;
						}
					}
				}
			}
		
			.service-c5 {
				width: 100%;
				// height: 850px;  
				display: flex; 
				padding: 30px 0;
				
				.service-c5-c {
					width: 100%;
					padding: 0 12px;
					.h {
						font-size: 18px;
						margin-bottom: 10px;
					}
					.f {
						width: 100%;
						margin-top: 20px;
						display: flex;
						flex-direction: column;
						.f-l {
							width: 100%;
							.item110 {
								margin-bottom: 12px;
								width: 100%;
								height: 60px;
								display: flex;
								.item5 {
									margin-bottom: 12px;
									width: calc(50% - 12px);
									div {
										font-size: 14px;
										margin-bottom: 8px;
									}
									input {
										width: 100%;
										height: 30px;
										margin-bottom: 0;
										
									}
								}
								
							}
							.item10 {
								width: 100%;
								div {
									font-size: 14px;
									margin-bottom: 8px;
								}
								input {
									width: 100%;
									height: 30px;
									margin-bottom: 0;
									
								}
							}
							
							.itemyz {
								margin-bottom: 12px;
								.itemyz-h {
									font-size: 12px;
									margin-bottom: 8px;
								}
								.itemyz-f {
									width: 100%;
									margin-top: 12px;
									display: flex;
									input {
										width: 180px;
										height: 30px;
									}  
									.code {
										margin-left: 12px;
										width: 100px;
										height: 30px;
										border: 1px solid #eee;
										line-height: 30px;
										border-radius: 4px;
									}
								}
							}
							.button {
								width: 120px;
								height: 40px;
								line-height: 40px;
							}
						}
						.f-r {
							width: 100%;
							margin-top: 20px;
							.s1 {
								font-size: 14px;
							}
							.s2 {
								margin-top: 12px;
								font-size: 24px;
							}
							.s3 {
								font-size: 14px;
							}
							img {
								display: none;
								margin-top: 30px;
								width: 180px;
								height: 180px;
							}
						}
					}
					
				
				}
			}
		}
	
	}
</style>
